<template>
  <div class="login">
    <span v-if="user" class="login-name">{{ user.email }}</span>
    <span v-if="user" class="login-btn" @click="handleLogout">登出</span>
    <span v-else class="login-btn" @click="handleLogin">登入</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAppUrl, getLoginPath } from "../../utils/domain";

export default {
  name: "Login",
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    handleLogin() {
      window.location.href = getAppUrl(getLoginPath());
    },
    handleLogout() {
      window.location.href = getAppUrl("/auth/logout");
    },
  },
  created() {
    this.$store.dispatch("getUser");
  },
};
</script>
<style lang="scss" scoped>
.login {
  display: inline-block;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-name {
    padding-right: 1rem;
    color: white;
    font-size: 1.5rem;
  }
  .login-btn {
    padding-right: 1rem;
    color: white;
    text-decoration: none;
    font-size: 1.5rem;
    cursor: pointer;
  }
}
</style>
